<template>
  <main id="page-wrap">
    <!-- <div class="grid-container"> -->
    <div class="grid-x">
      <!-- Main conten inside here -->

      <div class="cell small-12 medium-6 large-6 hide-for-small-only">
        <section class="login-img">
          <!-- <p>Här väntar</p> -->
          <h1>Ett nytt,<br />bättre hem,<br />väntar dig.</h1>
          <figure class="logo">
            <img src="img/bytbostad_outline.svg" alt="Bytbostad">
          </figure>
        </section>
      </div>

      <div class="cell small-12 medium-6 large-6">
        <div class="login-content">
          <div class="login-form-wrap">
            <LoginBox />
          </div>
        </div>
      </div>

      <!-- Main conten inside here : END -->
    </div>
  </main>
</template>

<script>
import LoginBox from '@/components/LoginBox.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    LoginBox
  },
  data () {
    return {
      loginImg: false
    }
  },
  watch: {
    // Set once the login has gone through (or straight away if already logged
    // in), which is when a ?redirect= link can be resumed.
    user: {
      immediate: true,
      handler (user) {
        if (user && this.redirect) {
          this.$router.replace(this.redirect)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    // Only same-site paths: never bounce a visitor off to another domain.
    redirect () {
      const target = this.$route.query.redirect
      if (typeof target !== 'string' || !/^\/[^/\\]/.test(target)) {
        return false
      }
      return target
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
